import React from "react";

// Mui Styles
import { StyledPaper } from "@/styles/mui/globalStyles";
import { TableListTheme } from "@/styles/mui/tableListTheme";
import { Button } from "@mui/material";
import { ThemeProvider, styled } from "@mui/material/styles";

// Navigate
import { useNavigate } from "react-router-dom";

// Components
import DataTable from "@/components/dataTable";
import Layout from "@/components/layout";
import Title from "@/components/title";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
// Fetch
import {
  approve,
  download,
  getCommissions,
  importDirectSales,
  updateToPendingCalculate,
} from "@/fetch/fetchCommission";
import { getAllUser } from "@/fetch/fetchStaff";

import { getProducts } from "@/fetch/fetchProduct";
import { importMonthlyTarget } from "@/fetch/fetchTarget";

import { importShopSales } from "@/fetch/fetchMannings";
import { getAllWorkLocation } from "@/fetch/fetchWork";
import extractDirectSalesData from "@/lib/extractDirectSalesData";
import extractManningsMonthlyData from "@/lib/extractManningsMonthlyData";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

import { useCurrentAction } from "@/hooks/user";
import _ from "lodash";

const CommissionPage = (props) => {
  const fileReader = new FileReader();

  const { open, setOpen } = props;
  const actions = useCurrentAction();

  const [dataTableLoading, setDataTableLoading] = React.useState(false);
  const [snackSeverity, setSnackSeverity] = React.useState("success");
  const [snackMessage, setSnackMessage] = React.useState("");
  const [snackOpen, setSnackOpen] = React.useState(false);
  // Navigate
  const navigate = useNavigate();
  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });
  const handleOnChange = (e, selectedDate) => {
    e.preventDefault();

    const file = e.target.files[0];

    if (file) {
      fileReader.onload = async function (event) {
        const text = event.target.result;

        const quoteChar = '"';
        const delimiter = ",";

        const regex = new RegExp(
          `\\s*(${quoteChar})?(.*?)\\1\\s*(?:${delimiter}|$)`,
          "gs"
        );

        const match = (line) =>
          [...line.matchAll(regex)]
            .map((m) => m[2]) // we only want the second capture group
            .slice(0, -1); // cut off blank match at the end

        var lines = text.split("\n");
        var result = [];

        // Read first row and display first column
        // var readVersion = lines[0].split(",");
        // var version = readVersion[0];

        var headers = match(lines.shift());
        // var headers = lines[1].split(",");
        // for (let i = 0; i < headers.length; i++) {
        //   headers[i] = headers[i].replace(`\r`, "");
        // }

        // Rows, skip 0
        for (var i = 0; i < lines.length; i++) {
          if (lines[i].length > 0) {
            var obj = {};
            var currentline = match(lines[i]);

            // Columns
            for (var j = 0; j < headers.length; j++) {
              if (currentline[j] !== "" && currentline[j] !== undefined) {
                if (headers[j] === "target_total_amount") {
                  if (isNaN(parseInt(currentline[j]))) {
                    setSnackMessage(
                      "target_total_amount is not a valid number value"
                    );
                    setSnackOpen(true);
                    setTimeout(() => {
                      setSnackOpen(false);
                    }, 1500);
                    return false;
                  } else {
                    obj[headers[j]] = currentline[j];
                  }
                } else {
                  obj[headers[j]] = currentline[j];
                }
              }
            }
            result.push(obj);
          }
        }

        // Output
        try {
          await importMonthlyTarget(
            moment(selectedDate).format("YYYY-MM-01"),
            result
          );
          await fetchAll();
          setSnackMessage(`上傳成功`);
        } catch (error) {
          console.error(error);
          setSnackMessage(`上傳失敗`);
        } finally {
          setSnackOpen(false);
        }
      };

      fileReader.readAsText(file);
    }
    e.target.value = null;
  };
  const handleImportDirectSales = async (e, selectedDate) => {
    try {
      setSnackOpen(true);
      setSnackSeverity("info");
      setSnackMessage("上載中.....");
      let productData = {};
      let userData = {};
      const { data } = await getProducts();
      const { data: users } = await getAllUser();
      _.forEach(users, (user) => {
        userData[user.customer_code] = user.id;
      });
      _.forEach(data, (d) => {
        productData[`${d.m18_product_code}-${d.region_id}`] = d.id;
      });
      let insertedrecord = 0;
      let updatedRecord = 0;
      let allRow = 0;
      for (let i = 0; i < e.target.files.length; i++) {
        const datas = await extractDirectSalesData(
          e.target.files[i],
          productData,
          userData,
          selectedDate
        );
        const { data: imported } = await importDirectSales({
          datas,
          date: moment(selectedDate).format("YYYY-MM-01"),
        });
        insertedrecord += parseInt(imported.ins);
        updatedRecord += parseInt(imported.upd);
        allRow += parseInt(imported.all_rows);
      }
      await fetchAll();
      setSnackSeverity("success");
      setSnackMessage(
        `上載成功,\n新增了${insertedrecord}條紀錄\n更新了${updatedRecord}條紀錄\n共${allRow}條紀錄`
      );
    } catch (error) {
      let message = "";
      switch (error.message) {
        case "dateIsNotCorrect":
          message = `上載失敗 \n 原因:日期不正確，數據必須於${moment(
            selectedDate
          ).format("YYYY年M月")}內`;
          break;
        case "productNotExist":
          message = `上載失敗\n以下產品不存在\n${error.id}`;
          break;
        default:
          message = "上載失敗";
          break;
      }
      setSnackSeverity("error");
      setSnackMessage(message);
      console.log(error);
    } finally {
    }
  };
  const handleImportShop = async (e, selectedDate) => {
    try {
      setSnackOpen(true);
      setSnackSeverity("info");
      setSnackMessage("上載中.....");
      let productData = {};
      let locationData = {};
      const { data } = await getProducts();
      const { data: locations } = await getAllWorkLocation();
      _.forEach(locations, (location) => {
        locationData[location.work_shortcode] = location.id;
      });
      _.forEach(data, (d) => {
        productData[_.padStart(d.mannings_product_code, 6, "0")] = {
          m18_product_code: _.padStart(d.m18_product_code, 6, "0"),
          product_id: d.id,
        };
      });
      let insertedrecord = 0;
      let updatedRecord = 0;
      let allRow = 0;
      for (let i = 0; i < e.target.files.length; i++) {
        const datas = await extractManningsMonthlyData(
          e.target.files[i],
          productData,
          locationData,
          selectedDate
        );
        const { data: imported } = await importShopSales(
          datas,
          moment(selectedDate).format("YYYY-MM-01")
        );
        insertedrecord += parseInt(imported.ins);
        updatedRecord += parseInt(imported.upd);
        allRow += parseInt(imported.all_rows);
      }
      await fetchAll();
      setSnackSeverity("success");
      setSnackMessage(
        `上載成功,\n新增了${insertedrecord}條紀錄\n更新了${updatedRecord}條紀錄\n共${allRow}條紀錄`
      );
    } catch (error) {
      let message = "";
      switch (error.message) {
        case "dateIsNotCorrect":
          message = `上載失敗 \n 原因:日期不正確，數據必須於${moment(
            selectedDate
          ).format("YYYY年M月")}內`;
          break;
        case "productNotExist":
          message = `上載失敗\n以下產品不存在\n${error.id}`;
          break;
        default:
          message = "上載失敗";
          break;
      }
      setSnackSeverity("error");
      setSnackMessage(message);
      console.log(error);
    } finally {
    }
  };
  const ManingsLandingTableColumn = [
    {
      field: "date",
      headerName: "佣金日期",
      flex: 1,
      renderCell: (params) => {
        return moment(params.row.date).format("YYYY年M月");
      },
    },
    // {
    //   field: "status",
    //   headerName: "狀態",
    //   flex: 1,
    // },
    {
      field: "target_monthly_list_count",
      headerName: "店鋪目標",
      renderCell: (params) => {
        let text = "";
        let color = "";
        let variant = "";
        let mode = "view";
        let onClick = () => {};
        if (params.row.status === "approved") {
          text = "查看設定";
          color = "success";
          variant = "contained";
          mode = "view";
          onClick = () =>
            navigate(
              `/monthlySetting/work/${moment(params.row.date).format(
                "YYYY-MM"
              )}`,
              { state: { mode } }
            );
        } else if (params.row.target_monthly_list_count > 0) {
          text = "更改設定";
          color = "info";
          variant = "contained";
          mode = "edit";
          onClick = () =>
            navigate(
              `/monthlySetting/work/${moment(params.row.date).format(
                "YYYY-MM"
              )}`,
              { state: { mode } }
            );
        } else {
          text = "上載";
          color = "info";
          variant = "outlined";
        }
        return (
          <Button
            variant={variant}
            role={undefined}
            disabled={!actions?.shopTarget}
            component="label"
            color={color}
            size="small"
            startIcon={
              params.row.target_monthly_list_count <= 0 ? (
                <CloudUploadIcon />
              ) : null
            }
            onClick={() => {
              actions?.shopTarget ? onClick() : alert("權限不足");
            }}
          >
            {text}
            {params.row.target_monthly_list_count <= 0 ? (
              <VisuallyHiddenInput
                type="file"
                onChange={(event) => handleOnChange(event, params.row.date)}
              />
            ) : null}
          </Button>
        );
      },
      flex: 1,
    },
    {
      field: "mannings_shop_sales_count",
      headerName: "店鋪數據",
      renderCell: (params) => {
        let text = "";
        let color = "";
        let variant = "";
        let onChange = () => {};
        if (params.row.status === "approved") {
          text = "已上載";
          color = "success";
          variant = "contained";
        } else if (
          params.row.mannings_shop_sales_count > 0 ||
          params.row.shop_data_uploaded
        ) {
          text = "重新上載";
          color = "info";
          variant = "contained";
          onChange = (event) => handleImportShop(event, params.row.date);
        } else {
          text = "上載";
          color = "info";
          variant = "outlined";
          onChange = (event) => handleImportShop(event, params.row.date);
        }
        return (
          <Button
            component="label"
            size="small"
            color={color}
            role={undefined}
            disabled={!actions?.shopData}
            variant={variant}
            startIcon={
              params.row.status === "approved" ? (
                <TaskAltIcon />
              ) : (
                <CloudUploadIcon />
              )
            }
          >
            {text}
            {params.row.status !== "approved" ? (
              <VisuallyHiddenInput
                type="file"
                onChange={(e) =>
                  actions?.shopData ? onChange(e) : alert("權限不足")
                }
              />
            ) : null}
          </Button>
        );
      },
      flex: 1,
    },
    {
      field: "direct_sales_count",
      headerName: "Direct Salse",
      renderCell: (params) => {
        let text = "";
        let color = "";
        let variant = "";
        let onChange = () => {};
        if (params.row.status === "approved") {
          text = "已上載";
          color = "success";
          variant = "contained";
        } else if (params.row.direct_sales_count > 0) {
          text = "重新上載";
          color = "info";
          variant = "contained";
          onChange = (event) => handleImportDirectSales(event, params.row.date);
        } else {
          text = "上載";
          color = "info";
          variant = "outlined";
          onChange = (event) => handleImportDirectSales(event, params.row.date);
        }
        return (
          <Button
            component="label"
            size="small"
            color={color}
            role={undefined}
            disabled={!actions?.shopData}
            variant={variant}
            startIcon={
              params.row.status === "approved" ? (
                <TaskAltIcon />
              ) : (
                <CloudUploadIcon />
              )
            }
          >
            {text}
            {params.row.status !== "approved" ? (
              <VisuallyHiddenInput
                type="file"
                onChange={(e) =>
                  actions?.shopData ? onChange(e) : alert("權限不足")
                }
              />
            ) : null}
          </Button>
        );
      },
      flex: 1,
    },
    {
      field: "commission_setting_count",
      headerName: "佣金設定",
      renderCell: (params) => {
        let text = "";
        let color = "";
        let variant = "";
        let mode = "view";
        let onClick = () => {};
        if (params.row.status === "approved") {
          text = "查看設定";
          color = "success";
          variant = "contained";
          mode = "view";
          onClick = () =>
            navigate(`setting/${params.row.commission_setting_id}`, {
              state: { mode },
            });
        } else if (params.row.commission_setting_id) {
          text = "更改設定";
          color = "info";
          variant = "contained";
          mode = "edit";
          onClick = () =>
            navigate(`setting/${params.row.commission_setting_id}`, {
              state: { mode },
            });
        } else {
          text = "新增設定";
          color = "info";
          variant = "outlined";
          mode = "edit";
          onClick = () =>
            navigate(`setting/create`, {
              state: {
                date: moment(params.row.date).format("YYYY-MM-01"),
                mode,
              },
            });
        }
        return (
          <Button
            variant={variant}
            color={color}
            disabled={!actions?.setting}
            size="small"
            onClick={() => (actions?.setting ? onClick() : alert("權限不足"))}
          >
            {text}
          </Button>
        );
      },
      flex: 1,
    },
    {
      field: "excel_path",
      headerName: "佣金計算",
      renderCell: (params) => {
        let text = "";
        let variant = "outlined";
        let color = "info";
        let onClick = () => {};
        switch (params.row.status) {
          case "pending":
            if (
              !params.row.commission_setting_id ||
              params.row.target_monthly_list_count <= 0
            ) {
              text = "先完成設定";
              color = "error";
            } else {
              text = "計算佣金";
              onClick = async () => {
                try {
                  await updateToPendingCalculate({
                    date: params.row.date,
                    commission_setting_id: params.row.commission_setting_id,
                    commission_id: params.row.id,
                  });
                  await fetchAll();
                  setSnackOpen(true);
                  setSnackMessage(
                    "已傳送計算指令，完成計算後佣金報告會傳送到你的電郵。"
                  );
                  setSnackSeverity("success");
                } catch (error) {
                  setSnackMessage("計算失敗");
                  setSnackSeverity("error");
                } finally {
                }
              };
            }
            break;
          case "generated":
          case "approved":
            text = "下載佣金報告";
            color = "success";
            variant = "contained";
            onClick = async () => {
              try {
                const { data: url } = await download({
                  id: params.row.id,
                });
                window.open(url, "_blank");
                setSnackMessage("下載成功");
                setSnackSeverity("success");
              } catch (error) {
                setSnackMessage("下載失敗");
                setSnackSeverity("error");
              }
              setSnackOpen(true);
            };
            break;
          case "pending_calculate":
            text = "等候中...";
            color = "warning";
            variant = "contained";
            break;
          case "calculating":
            text = "計算中...";
            color = "warning";
            variant = "contained";

            break;
          default:
            break;
        }
        return (
          <Button
            variant={variant}
            disabled={!actions?.calculation}
            color={color}
            size="small"
            onClick={() =>
              actions?.calculation ? onClick() : alert("權限不足")
            }
          >
            {text}
          </Button>
        );
      },
      flex: 1,
    },
    {
      field: "approve_user_alias",
      headerName: "批准人",
      flex: 1,
      renderCell: (params) => {
        return params.row.approve_user_alias ?? "--";
      },
    },
    {
      field: "approved_at",
      headerName: "批准時間",
      flex: 1,
      renderCell: (params) => {
        const approved_at = moment(params.row.approved_at);
        return approved_at.isValid()
          ? approved_at.format("YYYY-MM-DD HH:mm:ss")
          : "--";
      },
    },
    {
      field: "123",
      headerName: "動作",
      flex: 1,
      renderCell: (params) => {
        let text = "";
        let variant = "outlined";
        let color = "info";
        let onClick = () => {};
        switch (params.row.status) {
          case "pending":
            text = "先完成設定";
            color = "error";
            break;
          case "generated":
            text = "確認";
            color = "info";
            onClick = async () => {
              const answer = window.confirm(
                `確認後便不能更改${moment(params.row.date).format(
                  "YYYY年M月"
                )}的設定，${moment(params.row.date).format(
                  "YYYY年M月"
                )}的佣金正確嗎？`
              );
              if (answer) {
                try {
                  await approve({
                    date: params.row.date,
                    id: params.row.id,
                  });
                  await fetchAll();
                  setSnackMessage("確認成功");
                  setSnackSeverity("success");
                } catch (err) {
                  setSnackMessage("確認失敗");
                  setSnackSeverity("success");
                } finally {
                  setSnackOpen(true);
                }
              }
            };
            break;
          case "pending_calculate":
            text = "等候中...";
            color = "warning";
            variant = "contained";
            break;

          case "calculating":
            text = "計算中...";
            color = "warning";
            variant = "contained";

            break;
          case "approved":
            text = "已確認";
            color = "success";
            variant = "contained";
            break;
          default:
            break;
        }
        return (
          <Button
            variant={variant}
            color={color}
            disabled={!actions?.approve}
            size="small"
            onClick={() => (actions?.approve ? onClick() : alert("權限不足"))}
          >
            {text}
          </Button>
        );
      },
    },
  ];

  // States
  const [commissionData, setCommissionData] = React.useState([]);

  // const onCellClick = (data) => {
  //   navigate(`edit/${data.row.id}`);
  // };

  const fetchAll = async () => {
    try {
      setDataTableLoading(true);
      const { data } = await getCommissions();
      setCommissionData(data);
    } catch (error) {
      console.log("error", error);
    } finally {
      setDataTableLoading(false);
    }
  };
  React.useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout
      header="ExpensesPage"
      open={open}
      setOpen={setOpen}
      snackOpen={snackOpen}
      snackClose={() => setSnackOpen(false)}
      snackMessage={snackMessage}
      snackSeverity={snackSeverity}
    >
      <Title title="佣金" />
      <StyledPaper page={"yes"}>
        <ThemeProvider theme={TableListTheme}>
          <DataTable
            loading={dataTableLoading}
            rows={commissionData}
            columns={ManingsLandingTableColumn}
            pageSize={25}
          />
        </ThemeProvider>
      </StyledPaper>
    </Layout>
  );
};

export default CommissionPage;
